export default __webpack_public_path__ + "static/media/TradeRR.23a4b669.jpg";